import React from "react";
import { Route, Switch } from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import All from "./components/All";
import Smileys from "./components/Smileys";
import Food from "./components/Food";
import Symbols from "./components/Symbols";
import Objects from "./components/Objects";
import Animals from "./components/Animals";
import Flags from "./components/Flags";
import Travel from "./components/Travel";

function App() {
  return (
    <Switch>
      <Route path="/" exact component={Home} />
      <Route path="/all" exact component={All} />
      <Route path="/smileys" component={Smileys} />
      <Route path="/food" component={Food} />
      <Route path="/symbols" component={Symbols} />
      <Route path="/objects" component={Objects} />
      <Route path="/animals" component={Animals} />
      <Route path="/flags" component={Flags} />
      <Route path="/travel" component={Travel} />
    </Switch>
  );
}

export default App;
